import { render, staticRenderFns } from "./CoffeeCategory.vue?vue&type=template&id=7e502a00&scoped=true&"
import script from "./CoffeeCategory.vue?vue&type=script&lang=js&"
export * from "./CoffeeCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e502a00",
  null
  
)

export default component.exports